import { Listes } from "../Types/Listes";
import React, { useRef, useState } from "react";
import { Activity, Building2, Calendar, CalendarCheck, ChevronDown, ChevronUp, FileText, List, Package, PackageCheck, Paperclip, Phone, Receipt, Ship, Truck, TruckIcon, User, User2, UserCheck2Icon } from "lucide-react";
import jsPDF from "jspdf";
import { toast } from "react-toastify";
import { useAuth } from "../Services/AuthContext";
import { formatDateHeure } from "../Services/DataAction";
import { generateSinglePDF } from "../Services/generateSiglePDF";

interface BordereauCardProps{
    b:Listes;
    setForm:(data:any)=>void;
    setIsEditMode:(v:boolean)=>void;
    setIsModalOpen:(v:boolean)=>void;
    setSelectedUser:(b:Listes)=>void;
    setError:(e:string | null)=>void;
    onVerifie?: (b: Listes) => void;
    onDelete?: (b: Listes) => void;
    setIsModifier?: (v:boolean) => void;
}

const BordereauCard:React.FC<BordereauCardProps>=({b,setForm,setIsEditMode,setIsModalOpen,setSelectedUser, setError,onVerifie,onDelete,setIsModifier})=>{

    const { user } = useAuth();
    const isAdmin = !!user?.roles.includes("ROLE_ADMIN");
    const isMagasinLoin = !!user?.roles.includes("ROLE_MAGASIN_LOIN");
    const [showdetails,setShowDetails]=useState<boolean>(false);

  


const openModalModifier = (liste: Listes) => {
    setIsModifier?.(true);
    openModal(liste);
}
const openModalEdit = (liste: Listes) => {
  setIsEditMode(true);
  openModal(liste);
}

  const openModal = (liste: Listes) => {
    setIsModalOpen(true);
    setSelectedUser(liste);
    setError(null);
    console.log(liste);



    let rawDate = '';

  if (liste.Datelivraison) {
    if (typeof liste.Datelivraison === 'object' && 'date' in liste.Datelivraison) {
      rawDate = liste.Datelivraison.date;
    } else if (typeof liste.Datelivraison === 'string') {
      rawDate = liste.Datelivraison;
    }
  }

  const parsedDate = new Date(rawDate);

let formattedDateLivraison = '';
if (!isNaN(parsedDate.getTime())) {
  const timezoneOffset = parsedDate.getTimezoneOffset(); // en minutes
  const localDate = new Date(parsedDate.getTime() - timezoneOffset * 60000); // ajusté en local
  formattedDateLivraison = localDate.toISOString().slice(0, 16); // toujours en format attendu, mais local
}

    setForm({
      destinataire:liste.Destinataire,
      nombres:liste.Nombres,
      nombrepack:liste.Nombrepack,
      bon:liste.Bon,
      NumBl:liste.NumBl,
      livreur:liste.Livreur ,
      vehicule:liste.Vehicule ,
      chaffeur:liste.Chaffeur,
      telephone:liste.Telephone ,
      cooperative:liste.Cooperative ,
      datelivraison: formattedDateLivraison
    });

  };

    return (
      <div className="card bg-dark text-light border-0 shadow-lg rounded-4 h-100">
        <div className="card-body">

          <h5 className="card-title d-flex align-items-center gap-2 text-info mb-3">
            <User size={18} /> {b.Destinataire}
          </h5>

          <ul className="list-unstyled small">
            <li>
              <Receipt size={14} className="me-2 text-secondary" />{" "}
              <strong>Num bordereau :</strong> {b.NumberBordereau}
            </li>
            <li>
              <Package size={14} className="me-2 text-secondary" />{" "}
              <strong>{b.Nombres > 0 ? b.Nombres : 0} Colis et {b.Nombrepack > 0 ? b.Nombrepack : 0} Pack(s)</strong>
            </li>
            <li>
              <Paperclip size={14} className="me-2 text-secondary" />{" "}
              <strong>{b.Bon}</strong>
            </li>
            <li>
              <User2 size={14} className="me-2 text-secondary" />{" "}
              <strong>Magasin :</strong> {b.Expediteur}
            </li>
            <li>
                  <Calendar size={14} className="me-2 text-secondary" />{" "}
                  <strong>Livré le :</strong> {formatDateHeure(b.Datelivraison)}
            </li>
            <button className="btn btn-sm btn-outline-secondary mt-2" onClick={()=>setShowDetails(prev=> !prev)}>
              {showdetails ? (
                <>
                  <ChevronUp size={18} className="text-primary" />
                  <span>Fermer</span>
                </>
              ) : (
                <>
                  <ChevronDown size={18} className="text-primary" />
                  <span>Détails</span>
                </>
              )}
            </button>
            {showdetails && (
              <>
              <div className="mt-3">
                <h6 className="text-light">📋 Numéros de BL :</h6>
                <ul className="list-group list-group-flush">
                  {b.NumBl && b.NumBl.length > 0 ?(
                    b.NumBl.map((l,index)=>(
                      <li key={index} className="bg-transparent text-light d-flex align-items-center gap-2">
                        <List size={14} className="text-secondary"/>
                        <strong>{l}</strong>
                      </li>
                    ))
                  ):(
                    <strong>Aucun numéro BL.</strong>
                  )}
                </ul>
              </div>
              <div className="mt-3">
                <li>
                  <CalendarCheck size={14} className="me-2 text-secondary" />{" "}
                  <strong>Créer le :</strong> {formatDateHeure(b.Date)}
                </li>
              </div>
              </>
            )}
            <hr className="my-2 border-light" />
            {
              b.isSend ? (
                <>
                <li>
                  <Truck size={14} className="me-2 text-secondary" />{" "}
                  <strong>Livreur :</strong> {b.Livreur}
                </li>
                <li>
                  <UserCheck2Icon size={14} className="me-2 text-secondary" />{" "}
                  <strong>Chauffeur :</strong> {b.Chaffeur || "-"}
                </li>
                <li>
                  <TruckIcon size={14} className="me-2 text-secondary" />{" "}
                  <strong>Véhicule :</strong> {b.Vehicule || "-"}
                </li>
                <li>
                  <Building2 size={14} className="me-2 text-secondary" />{" "}
                  <strong>Coopérative :</strong> {b.Cooperative || "-"}
                </li>
                <li>
                  <Phone size={14} className="me-2 text-secondary" />{" "}
                  <strong>Téléphone :</strong> {b.Telephone || "-"}
                </li>

                </>
              ):''
            }

          </ul>

          <div className="mt-3 d-flex gap-2 flex-wrap">
            <span
              className={`badge px-3 py-2 ${
                b.isSend ? "bg-success" : "bg-warning text-dark"
              }`}
            >
              {b.isSend ? "✅ Livré" : "⏳ Pas encore livré"}
            </span>
            <span
              className={`badge px-3 py-2 ${
                b.isVerified ? "bg-primary" : "bg-secondary"
              }`}
            >
              {b.isVerified ? "✔️ Validé" : "❌ Non vérifié"}
            </span>
          </div>
        </div>

        <div className="card-footer border-0 bg-transparent d-flex justify-content-center gap-2 flex-wrap">
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => openModalEdit(b)}
          >
            <Truck /> Livraison
          </button>

          {(!b.isVerified && (isAdmin || isMagasinLoin)) && (
              <button
                className="btn btn-sm btn-outline-success"
                onClick={() =>{if (onVerifie){onVerifie(b)} else {toast.error("Action non autorisée");}}}
              >
                ✔️ Vérifier
              </button>
          )}

          {(isAdmin || isMagasinLoin) && (
            <>
            <div className="dropdown text-end">
              <button
                className="btn btn-sm btn-light"
                type="button"
                id="dropdownMenuButton"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="bi bi-three-dots-vertical"></i>
              </button>

              <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li>
                  <button className="dropdown-item" onClick={() => openModalModifier(b)}>
                    ✏️ Modifier
                  </button>
                </li>
                <li>
                  <button className="dropdown-item" onClick={() => { if (onDelete){onDelete(b);} else {toast.error("Action non autorisée ");} }}>
                    ❌ Supprimer
                  </button>
                </li>
              </ul>
            </div>

            </>
          )}

          {b.isVerified && (
              <button
                className="btn btn-sm btn-outline-info"
                onClick={() => generateSinglePDF(b)}
              >
                📄 Télécharger PDF
              </button>
          )}
        </div>

      </div>
    );
  };

export default BordereauCard;